import { CertificateGrid } from "@templates/CertificatesGrid";
import { ClientSlider } from "@templates/ClientSlider";
import { Faq } from "@templates/Faq";
import { Footer } from "@templates/Footer";
import { Header } from "@templates/Header";
import { InitialIntro } from "@templates/InitialIntro";
import { Plans } from "@templates/Plans";
import { Resources } from "@templates/Resources";
import { TestimonialsSlider } from "@templates/TestimonialsSlider";

// Header
const headerElement = document.getElementById("header-main");
if (headerElement) headerElement.appendChild(Header());

// Initial Intro [Nossos Planos, Recursos, Depoimentos, Certificados e Faq]
const introsElementIds = [
  "initial-intro-plans",
  "initial-intro-resources",
  "initial-intro-testimonials",
  "initial-intro-certificates",
  "initial-intro-faq",
];

introsElementIds.forEach((id) => {
  const initialIntroPlansElement = document.getElementById(id);

  if (initialIntroPlansElement) {
    const badgeText = initialIntroPlansElement?.getAttribute("badgeText");
    const strongText = initialIntroPlansElement?.getAttribute("strongText");
    const description = initialIntroPlansElement?.getAttribute("description");
    const descriptionClass =
      initialIntroPlansElement?.getAttribute("descriptionClass");

    if (strongText)
      initialIntroPlansElement.appendChild(
        InitialIntro({
          badgeText,
          strongText,
          description,
          descriptionClass,
        }),
      );
  }
});

// Plans
const plansElement = document.getElementById("plans-container");
if (plansElement) plansElement.appendChild(Plans());

// Resources
const resourcesElement = document.getElementById("resources-container");
if (resourcesElement) resourcesElement.appendChild(Resources());

// Client Slider
const clientSliderElement = document.getElementById("client-slider");
if (clientSliderElement) clientSliderElement.appendChild(ClientSlider());

// Testimonials
const testimonialsContainerElement = document.getElementById(
  "testimonials-container",
);
if (testimonialsContainerElement)
  testimonialsContainerElement.appendChild(TestimonialsSlider());

// Certificates
const certificatesContainerElement = document.getElementById(
  "certificates-container",
);
if (certificatesContainerElement)
  certificatesContainerElement.appendChild(CertificateGrid());

// Faq
const faqContainerElement = document.getElementById("faq-container");
if (faqContainerElement) faqContainerElement.appendChild(Faq());

// Footer
const footerElement = document.getElementById("footer-main");
if (footerElement) footerElement.appendChild(Footer());
